import { render, staticRenderFns } from "./AppCardButton.vue?vue&type=template&id=1395cf0f&scoped=true&"
import script from "./AppCardButton.vue?vue&type=script&lang=js&"
export * from "./AppCardButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1395cf0f",
  null
  
)

export default component.exports